// This file is auto-generated during the build process
export const BUILD_VERSION = "20260826-3";
export const BUILD_DATE = "2026-08-26T12:39:28.250Z";
